import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RoomCreatedModal = ({ createdRoomData  }) => {

  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const query = createdRoomData.roomType === 'private' ? `?key=${createdRoomData.roomKey}` : '';
  const roomUrl = `${window.location.origin}/room/${createdRoomData.roomId}${query}`;
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    const timer = setTimeout(() => {
          navigate(`/room/${createdRoomData.roomId}${query}`, {
            state: { createdRoomData },
          });
        }, 5000);

        return () => {
          clearInterval(countdownInterval);
          clearTimeout(timer);
        };
      }, [createdRoomData.roomId, createdRoomData, navigate, query]);

  const handleCopy = () => {
    navigator.clipboard.writeText(roomUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
      <div className="bg-yellow relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-xl p-6 sm:p-8 shadow-xl transition-all duration-300 animate-fade-in text-black" >

        <h2 className="text-3xl font-bold text-center mb-4">Game successfully created!</h2>
        <p className="text-center text-sm mb-4 roboto-f">Redirecting you to the game in <span className="font-bold">{countdown}</span> ...</p>
  
        <p className="text-center text-sm mb-6 roboto-f">
          Game ID: <code className="font-mono">{createdRoomData.roomId}</code>
        </p>

        <div className="flex justify-center">
          <button
            className="font-bold relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
              bg-[#FF1111] rounded-2xl shadow-[0_6px_0_0_#C30F0F]
              transition-all duration-150 ease-in-out
              hover:scale-[1.03]
              hover:brightness-110
              active:translate-y-[4px] active:shadow-none"
                onClick={handleCopy}
            >
            Copy and share
          </button>
        </div>
  
        {copied && (
          <p className="mt-4 text-sm text-center roboto-f">
            Game link copied to clipboard!
          </p>
        )}
      </div>
    </div>
  );
  
};

export default RoomCreatedModal;
